export const getUnreadMessagesCount = (thread, userId) => {

    if(!thread || !userId) return 0;

    for (const record of thread.lastRead) {
        if(record.userId?.toString() === userId?.toString()){            
            return record?.unreadCount;
        }
        
    }

    return 0;
}